module.exports = __webpack_public_path__ + "0b72383e32327debf33432d5351eb1fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/heart-icon-filled.svg
// module id = 2547
// module chunks = 0